export const D365_USER_ID = 'd365_user_id';
export const SHOW_PROFILE_TOAST = 'profile_toast';

export const FORMTYPES = {
  EDIT_SECONDARY_USER: 'editSecondaryUser',
  EDIT_PRIMARY_USER: 'editPrimaryUser',
  EDIT_EMAIL: 'editEmail',
};

export const HEADING_LABELS = {
  ADD_SECONDARY_USER: 'Add secondary user',
  EDIT_SECONDARY_USER: 'Edit secondary user',
  EDIT_PRIMARY_USER: 'Edit primary user name',
  EDIT_EMAIL: 'Edit email',
  ADD_EMAIL: 'Add email',
};

export const PROFILE_FIELD_LABELS = {
  PRIMARY_USER: 'PRIMARY USER',
  SECONDARY_USER: 'SECONDARY USER',
  EMAIL: 'EMAIL',
};

export const PROFILE_INFORMATION_UPDATE_MESSAGE =
  'Profile updated successfully. Changes will reflect in a few seconds.';

export const PROFILE_MODAL_STYLING = {
  className:
    'bg-white px-4 py-6 md:px-s6 md:py-s7 !mt-0 md:mt-0 border-0 md:border-0 rounded-xl rounded-bl-none rounded-br-none',
  btnClassName: '!mt-s8',
  titleClassName: 'tracking-normal text-h-2 text-cti-primary',
  contentClassName: 'mt-2 md:mt-1 body-lg text-cti-secondary',
  mobileBtnClassName: '!static !p-0 !pt-0 md:p-6 md:pt-6',
};
